<template>
  <span :onload="fullName">{{ full_name }}</span>
</template>

<script>
export default {
  name: "CellRendererName",
  data () {
    return {
      full_name: null
    }
  },
  computed: {
    fullName () {
      // console.log("params", this.params)
      if (this.params.data.first_name !== null) this.full_name = (this.params.data.first_name).concat(" ").concat(this.params.data.last_name)
    }
  }
};
</script>

<style lang="scss" scpoped>

</style>
